// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"78048724","248":"3d8c59d5","291":"78048724","650":"eb446400","745":"9053f578","920":"d3c1f204"}[chunkId] + ".chunk.css";
};